var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ruleForm, rules: _vm.rules, "label-width": "100px" }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "是否开票", prop: "isBilling" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ruleForm.isBilling,
                callback: function($$v) {
                  _vm.$set(_vm.ruleForm, "isBilling", $$v)
                },
                expression: "ruleForm.isBilling"
              }
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "付款类型", prop: "paymentMethod" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ruleForm.paymentMethod,
                callback: function($$v) {
                  _vm.$set(_vm.ruleForm, "paymentMethod", $$v)
                },
                expression: "ruleForm.paymentMethod"
              }
            },
            [
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("回付")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("到付")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "需要回单", prop: "isNeedReceipt" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.ruleForm.isNeedReceipt,
                callback: function($$v) {
                  _vm.$set(_vm.ruleForm, "isNeedReceipt", $$v)
                },
                expression: "ruleForm.isNeedReceipt"
              }
            },
            [
              _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: "0" } }, [_vm._v("否")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-6f4d9a31", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-6f4d9a31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/components/costInfoWrapper/index.vue
// module id = null
// module chunks = 